import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { postNewReportCSV } from 'Services';
import { RQ_SINGLE_REPORT_CSV } from 'Utils';
import { useTranslation } from 'react-i18next';
import useReportCsvErrorHandler from './useReportCsvErrorHandler';

function useCreateSingleReportCSV(type: ReportType, extendedFormValues?: ProcessedNewMerchantReportFormValues) {
    const { t } = useTranslation();
    const errorHandler = useReportCsvErrorHandler({
        preContentMessage: t('Failed to export CSV'),
        title: t('Unable to export CSV')
    });

    const values = {
        type,
        properties: {
            ...extendedFormValues
        }
    };

    const [shouldPoll, setShouldPoll] = useState(false);
    const [allowedToFetch, setAllowedToFetch] = useState(false);

    return useQuery([RQ_SINGLE_REPORT_CSV, values], () => postNewReportCSV(values), {
        enabled: allowedToFetch,
        onSuccess: (response) => {
            setAllowedToFetch(true);
            if (response.status === 200) {
                setAllowedToFetch(false);
                setShouldPoll(false);
                const [, filename] = response.headers['content-disposition'].split('filename=');
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.download = `${filename}`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            } else {
                setShouldPoll(true);
            }
        },
        onError: (error) => {
            setAllowedToFetch(false);
            setShouldPoll(false);
            errorHandler(error);
        },
        refetchInterval: shouldPoll ? 5000 : false,
        refetchIntervalInBackground: true,
        refetchOnWindowFocus: false
    });
}

export default useCreateSingleReportCSV;
